module.exports = __webpack_public_path__ + "img/person.40b4f775.svg";